import { RouteRecordRaw } from 'vue-router'

const materialStorage: Array<RouteRecordRaw> = [
  {
    path: '/materialStorage',
    name: 'materialStorage',
    redirect: '/materialStorage/wTransfer',
    component: () => import('@/views/children.vue'),
    children: [
      {
        path: '/materialStorage/wTransfer',
        name: 'wTransfer',
        meta: {
            title: '转库单列表',
            keepAlive: false
        },
        component: () => import('@/views/materialStorage/wTransfer.vue')
      },
      {
        path: '/materialStorage/wTransferDetail',
        name: 'wTransferDetail',
        meta: {
          title: '转库单详情',
          keepAlive: false
        },
        component: () => import('@/views/materialStorage/wTransferDetail.vue')
      },
      {
        path: '/materialStorage/wOutbound',
        name: 'wOutbound',
        meta: {
            title: '出库单列表',
            keepAlive: false
        },
        component: () => import('@/views/materialStorage/wOutbound.vue')
      },
      {
        path: '/materialStorage/wOutboundDetail',
        name: 'wOutboundDetail',
        meta: {
          title: '出库单详情',
          keepAlive: false
        },
        component: () => import('@/views/materialStorage/wOutboundDetail.vue')
      },
      {
        path: '/materialStorage/wInbound',
        name: 'wInbound',
        meta: {
            title: '入库单列表',
            keepAlive: false
        },
        component: () => import('@/views/materialStorage/wInbound.vue')
      },
      {
        path: '/materialStorage/wInboundDetail',
        name: 'wInboundDetail',
        meta: {
          title: '入库单详情',
          keepAlive: false
        },
        component: () => import('@/views/materialStorage/wInboundDetail.vue')
      },
      {
        path: '/materialStorage/inventory',
        name: 'inventory',
        meta: {
          title: '库存量查询',
          keepAlive: false
        },
        component: () => import('@/views/materialStorage/inventory.vue')
      }
    ]
  }
]

export default materialStorage